import { MODULES_REQUEST, MODULES_RECEIVED } from 'redux/actions/modules';

const initialState = {
  hasError: false,
  modules: [],
  modulesLoading: false,
};

export default function module(state = initialState, action) {
  switch (action.type) {
    case MODULES_REQUEST:
      return Object.assign({}, state, {
        hasError: false,
        modules: [...state.modules],
        modulesLoading: true,
      });
    case MODULES_RECEIVED:
      return Object.assign({}, state, {
        hasError: false,
        modules: action.modules,
        modulesLoading: false,
      });
    default:
      return state;
  }
}
